import styled from 'styled-components';

export const ConfigManagerWrapper = styled.div`
  padding: 30px 50px;
`;
